<template>
  <div style="height: 100%;background-color: #fbfbfb">
    <div style="height: calc(100% - 20px);margin: 0 20px;padding-top: 20px">
      <el-row style="height: 100%;">
        <el-col :span="4" style="height: 100%;overflow-y: hidden">
          <tree-organize ref="org" :treeObj="treeObj" @getOrgArr="getOrgArr"></tree-organize>
        </el-col>
        <el-col :span="20" style="height: 100%;">
          <div style="height: 100%;margin: 0 20px">
            <div style="height: 50px;"><el-button type="primary" plain icon="el-icon-plus" @click="addStaff()">新建</el-button></div>
            <div style="max-height: calc(100% - 100px);overflow-y: auto">
              <el-table :data="tableData" border highlight-current-row ref="singleTable">
                <el-table-column
                  type="index"
                  label="序号"
                  width="70"
                  align="center">
                </el-table-column>
                <el-table-column
                  label="所属楼栋/楼层"
                  min-width="110"
                  align="center">
                  <template slot-scope="scope">
                    <span>{{getOrgShowName(scope.row.orgid)}}</span>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="room"
                  label="房间号"
                  min-width="60"
                  align="center">
                </el-table-column>
                <el-table-column
                  label="房间类型"
                  min-width="60"
                  align="center">
                  <template slot-scope="scope">
                    <span>{{getTypeRoomShowName(scope.row)}}</span>
                  </template>
                </el-table-column>
                <el-table-column
                  label="床位价格"
                  min-width="70"
                  align="center">
                  <template slot-scope="scope">
                    <span v-if="scope.row.extra_info !== null && scope.row.extra_info !== ''">{{scope.row.extra_info.bedPrice}}</span>
                  </template>
                </el-table-column>
                <el-table-column
                  label="包月价格"
                  min-width="70"
                  align="center">
                  <template slot-scope="scope">
                    <span v-if="scope.row.extra_info !== null && scope.row.extra_info !== ''">{{scope.row.extra_info.bedMonthPrice}}</span>
                  </template>
                </el-table-column>
                <el-table-column
                  label="是否安装电视"
                  min-width="70"
                  align="center">
                  <template slot-scope="scope">
                    <span v-if="scope.row.extra_info !== null && scope.row.extra_info !== ''">
                      <span v-if="scope.row.extra_info.isHaveTV === 1">是</span>
                      <span v-if="scope.row.extra_info.isHaveTV === 0">否</span>
                    </span>
                  </template>
                </el-table-column>
                <el-table-column
                  label="是否有卫生间"
                  min-width="70"
                  align="center">
                  <template slot-scope="scope">
                   <span v-if="scope.row.extra_info !== null && scope.row.extra_info !== ''">
                      <span v-if="scope.row.extra_info.isHaveToilet === 1">是</span>
                      <span v-if="scope.row.extra_info.isHaveToilet === 0">否</span>
                    </span>
                  </template>
                </el-table-column>
                <el-table-column
                  label="房间描述"
                  min-width="70"
                  align="center">
                  <template slot-scope="scope">
                    <span v-if="scope.row.extra_info !== null && scope.row.extra_info !== ''">{{scope.row.extra_info.description}}</span>
                  </template>
                </el-table-column>
                <el-table-column
                  label="床位信息"
                  min-width="70"
                  align="center">
                  <template slot-scope="scope">
                    <el-button size="mini" type="primary" plain @click="openBedDetails(scope.row)">床位详情</el-button>
                  </template>
                </el-table-column>
                <el-table-column align="center" label="操作" width="80">
                  <template slot-scope="scope">
                    <i title="编辑" class="el-icon-edit" style="cursor: pointer; font-size: 18px;color: #1ae517" @click="editRoom(scope.row)"></i>
                    <i title="删除" class="el-icon-delete" style="cursor: pointer; font-size: 18px;color: red" @click="delRoom(scope.row)"></i>
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <div style="margin-top: 10px;height: 40px;text-align: center">
              <el-pagination v-fixZoom @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage"
                             :page-sizes="[10, 20, 50, 100]" :page-size="pageSize" :total="totalCells"
                             layout="total, sizes, prev, pager, next, jumper">
              </el-pagination>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
    <el-dialog :visible.sync="addEditShow" v-if="addEditShow" width="800px"
               :show-close="true" :close-on-click-modal="false" center class="all-open">
      <div class="title-top-alarm">
        <span>{{ addEditTitle }}</span>
        <div class="line-title"></div>
      </div>
      <add-edit-room :roomRow="roomRow" v-model="addEditShow" @updateTable="updateTable"></add-edit-room>
    </el-dialog>
    <el-dialog :visible.sync="bedShow" v-if="bedShow" width="900px"
               :show-close="true" :close-on-click-modal="false" center class="all-open">
      <div class="title-top-alarm">
        <span>{{roomRow.row.room}} - 床位信息</span>
        <div class="line-title"></div>
      </div>
      <open-bed-list :roomRow="roomRow" v-model="bedShow"></open-bed-list>
    </el-dialog>
  </div>
</template>

<script>
import treeOrganize from './components/treeOrganize'
import addEditRoom from './components/addEditRoom'
import openBedList from './components/openBedList'
import {queryorghomepage, queryorghomebyorgid} from '../../api/yanglaoyuan'
import {deleteorghome} from '../../api/relation'
export default {
  name: 'roomManagement',
  components: {treeOrganize, addEditRoom, openBedList},
  data () {
    return {
      loading: false,
      orgArr: [],
      treeOrg: [],
      treeNode: '',
      treeObj: {
        orgData: []
      },
      pageSize: 10,
      currentPage: 1,
      totalCells: 0,
      tableData: [],
      addEditTitle: '新增房间',
      addEditShow: false,
      roomRow: {
        isAdd: true,
        room: '',
        orgArr: [],
        treeOrg: '',
        treeData: []
      },
      roomTypes: [
        {id: 0, name: '单人间'},
        {id: 1, name: '双人间'},
        {id: 2, name: '三人间'},
        {id: 3, name: '四人间'},
        {id: 4, name: '五人间'},
        {id: 5, name: '六人间'}
      ],
      bedShow: false
    }
  },
  created () {
    this.getTableDataRoom()
  },
  methods: {
    getOrgArr (obj) {
      if (obj.type === 'orgArr') {
        this.orgArr = obj.arr
        this.roomRow.orgArr = obj.arr
        this.getOrTree1()
      } else if (obj.type === 'org') {
        this.treeOrg = obj.arr
      } else if (obj.type === 'node') {
        // 点击树组织
        this.treeNode = obj.node
        this.currentPage = 1
        this.pageSize = 10
        this.getTableDataRoomByOrgid()
        console.log('点击')
      }
    },
    getOrTree1 () {
      // 所属组织
      let lastLevel = 100
      const arr = []
      for (let i = 0; i < this.orgArr.length; i++) {
        let obj = this.clone(this.orgArr[i])
        if (this.orgArr[i].org_type === 0 || this.orgArr[i].org_type === 1) {
          obj.disabled = true
        } else {
          obj.disabled = false
        }
        arr.push(obj)
      }
      for (let i = 0; i < arr.length; i++) {
        if (arr[i].level < lastLevel) {
          lastLevel = arr[i].level
        }
      }
      let treeData = []
      for (let i = 0; i < arr.length; i++) {
        if (arr[i].level === lastLevel) {
          treeData.push(arr[i])
        }
      }
      for (let i = 0; i < treeData.length; i++) {
        const child = this.arrayToNode1(arr, treeData[i].id)
        if (child.length !== 0) {
          treeData[i].child = child
        }
      }
      // console.log(999, arr, treeData)
      this.roomRow.treeData = treeData
    },
    arrayToNode1 (nodesArray, pid) {
      const vm = this
      return nodesArray.filter(value => {
        if (value.orgpid === pid) {
          const arrayToNode = vm.arrayToNode1(nodesArray, value.id)
          if (arrayToNode.length > 0) {
            value.child = arrayToNode
          }
          return value
        }
      })
    },
    getTableDataRoomByOrgid () {
      let params = {
        page: this.currentPage,
        size: this.pageSize
      }
      let data = {
        orgid: this.treeNode.id
      }
      queryorghomebyorgid(params, data).then(res => {
        this.totalCells = res.data.cnt
        let arr = []
        let orghomes = res.data.orghomes
        for (let i = 0; i < orghomes.length; i++) {
          if (orghomes[i].extra_info !== null && orghomes[i].extra_info !== '') {
            orghomes[i].extra_info = JSON.parse(orghomes[i].extra_info)
          }
          arr.push(orghomes[i])
        }
        this.tableData = arr
      }).catch(() => {})
    },
    getTableDataRoom () {
      if (this.treeNode !== '') {
        this.getTableDataRoomByOrgid()
        return
      }
      let params = {
        page: this.currentPage,
        size: this.pageSize
      }
      queryorghomepage(params).then(res => {
        this.totalCells = res.data.cnt
        let arr = []
        let orghomes = res.data.orghomes
        for (let i = 0; i < orghomes.length; i++) {
          if (orghomes[i].extra_info !== null && orghomes[i].extra_info !== '') {
            orghomes[i].extra_info = JSON.parse(orghomes[i].extra_info)
          }
          arr.push(orghomes[i])
        }
        this.tableData = arr
      }).catch(() => {})
    },
    getOrgShowName (orgid) {
      let name = orgid
      let orgpid = ''
      for (let i = 0; i < this.orgArr.length; i++) {
        if (this.orgArr[i].id === orgid) {
          name = this.orgArr[i].name
          orgpid = this.orgArr[i].orgpid
        }
      }
      if (orgpid !== '') {
        for (let i = 0; i < this.orgArr.length; i++) {
          if (this.orgArr[i].id === orgpid) {
            name = this.orgArr[i].name + ' / ' + name
          }
        }
      }
      return name
    },
    getTypeRoomShowName (row) {
      let name = ''
      if (row.extra_info !== null) {
        this.roomTypes.forEach((item) => {
          if (item.id === row.extra_info.roomType) {
            name = item.name
          }
        })
      }
      return name
    },
    openBedDetails (row) {
      this.roomRow.row = row
      this.bedShow = true
    },
    addStaff () {
      this.roomRow.isAdd = true
      this.roomRow.row = ''
      this.addEditTitle = '新增房间'
      this.addEditShow = true
    },
    editRoom (row) {
      this.roomRow.isAdd = false
      this.roomRow.row = row
      this.addEditTitle = '编辑房间'
      this.addEditShow = true
    },
    delRoom (row) {
      let name = row.room
      this.$confirm('此操作将永久删除该房间【' + name + '】, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'error'
      }).then(() => {
        let data = {
          homeids: [row.id]
        }
        deleteorghome(data).then(() => {
          this.getTableDataRoom()
          this.$notify({ title: '成功', message: '成功删除房间', type: 'success', duration: 2000 })
        }).catch(() => {
          this.$notify.error({ title: '失败', message: '删除房间失败' })
        })
      }).catch(() => {})
    },
    handleSizeChange (val) {
      this.pageSize = val
      this.getTableDataRoom()
    },
    handleCurrentChange (val) {
      this.currentPage = val
      this.getTableDataRoom()
    },
    updateTable () {
      this.getTableDataRoom()
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/oldPersonHome/roomManagement.vue